// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"bd7e85f0","1180":"bd7e85f0","2754":"bd7e85f0","3298":"bd7e85f0","3319":"cebb2e9f","5006":"20eaeba5","5563":"bd7e85f0","8504":"bd7e85f0"}[chunkId] + ".chunk.css";
};